(function () {
  const fixedHeaders = new Set();
  let scrollListenerReady = false;

  function updateFixedHeader(header) {
    const section = header.closest('.site-header-section');
    const spacer = section && section.querySelector('[data-header-spacer]');
    if (!spacer) return;

    const announcement = document.querySelector('.announcement-bar');
    const shouldFix =
      !announcement || announcement.getBoundingClientRect().bottom <= 0;

    if (shouldFix) {
      header.classList.add('is-fixed');
      spacer.style.height = `${header.offsetHeight}px`;
    } else {
      header.classList.remove('is-fixed');
      spacer.style.height = '0';
    }
  }

  function updateAllFixedHeaders() {
    fixedHeaders.forEach(updateFixedHeader);
  }

  function ensureFixedScrollListener() {
    if (scrollListenerReady) return;
    scrollListenerReady = true;

    window.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(updateAllFixedHeaders);
      },
      { passive: true }
    );

    window.addEventListener('resize', updateAllFixedHeaders);
  }

  function initFixedHeader(header) {
    fixedHeaders.add(header);
    ensureFixedScrollListener();
    updateFixedHeader(header);
  }

  function closeMobilePanels(mobileNav) {
    mobileNav.querySelectorAll('[data-mobile-panel]').forEach((panel) => {
      const isRoot = panel.dataset.mobilePanel === 'root';
      panel.hidden = !isRoot;
    });
  }

  function initHeader(root) {
    const header = root.matches('.site-header') ? root : root.querySelector('.site-header');
    if (!header) return;

    const sectionId = header.dataset.sectionId;
    if (header.dataset.initialized === sectionId) return;
    header.dataset.initialized = sectionId;

    initFixedHeader(header);

    const section = header.closest('.site-header-section');
    const toggle = header.querySelector('[data-header-toggle]');
    const mobileNav = header.querySelector('[data-header-mobile]');

    if (toggle && mobileNav) {
      const overlay = section && section.querySelector('[data-header-overlay]');
      const labelOpen = toggle.dataset.labelOpen || 'Menu';
      const labelClose = toggle.dataset.labelClose || 'Close menu';

      const setMobileOpen = (open) => {
        header.classList.toggle('site-header--mobile-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? labelClose : labelOpen);
        mobileNav.hidden = !open;

        if (overlay) {
          overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
        }

        if (!open) closeMobilePanels(mobileNav);
        updateFixedHeader(header);
      };

      toggle.addEventListener('click', () => {
        setMobileOpen(!header.classList.contains('site-header--mobile-open'));
      });

      overlay &&
        overlay.addEventListener('click', () => {
          setMobileOpen(false);
        });
    }

    mobileNav &&
      mobileNav.querySelectorAll('[data-mobile-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const target = trigger.dataset.mobileOpen;
          const panel = mobileNav.querySelector(`[data-mobile-panel="${target}"]`);
          if (!panel) return;
          mobileNav.querySelectorAll('[data-mobile-panel]').forEach((p) => {
            p.hidden = true;
          });
          panel.hidden = false;
        });
      });

    mobileNav &&
      mobileNav.querySelectorAll('[data-mobile-back]').forEach((button) => {
        button.addEventListener('click', () => {
          closeMobilePanels(mobileNav);
        });
      });

    header.querySelectorAll('[data-header-nav-item]').forEach((item) => {
      const trigger = item.querySelector('[data-header-nav-trigger]');
      const panel = item.querySelector('[data-header-dropdown]');
      if (!trigger || !panel) return;

      const openItem = () => {
        header.querySelectorAll('[data-header-nav-item].is-open').forEach((openEl) => {
          if (openEl !== item) {
            openEl.classList.remove('is-open');
            const openPanel = openEl.querySelector('[data-header-dropdown]');
            const openTrigger = openEl.querySelector('[data-header-nav-trigger]');
            if (openPanel) openPanel.hidden = true;
            if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      };

      const closeItem = () => {
        item.classList.remove('is-open');
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      };

      item.addEventListener('mouseenter', openItem);
      item.addEventListener('mouseleave', closeItem);
      item.addEventListener('focusin', openItem);
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) closeItem();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.site-header').forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const header = event.target.querySelector('.site-header');
    if (header) header.dataset.initialized = '';
    initHeader(event.target);
    updateAllFixedHeaders();
  });
})();
